var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55864_33228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55864_33228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.875C12.2245 21.875 11.9936 21.7818 11.8073 21.5955C11.6209 21.4091 11.5278 21.1782 11.5278 20.9028V14.0972H4.72222C4.44676 14.0972 4.21586 14.0041 4.02951 13.8177C3.84317 13.6314 3.75 13.4005 3.75 13.125C3.75 12.8495 3.84317 12.6186 4.02951 12.4323C4.21586 12.2459 4.44676 12.1528 4.72222 12.1528H11.5278V5.34722C11.5278 5.07176 11.6209 4.84086 11.8073 4.65451C11.9936 4.46817 12.2245 4.375 12.5 4.375C12.7755 4.375 13.0064 4.46817 13.1927 4.65451C13.3791 4.84086 13.4722 5.07176 13.4722 5.34722V12.1528H20.2778C20.5532 12.1528 20.7841 12.2459 20.9705 12.4323C21.1568 12.6186 21.25 12.8495 21.25 13.125C21.25 13.4005 21.1568 13.6314 20.9705 13.8177C20.7841 14.0041 20.5532 14.0972 20.2778 14.0972H13.4722V20.9028C13.4722 21.1782 13.3791 21.4091 13.1927 21.5955C13.0064 21.7818 12.7755 21.875 12.5 21.875Z",
    fill: "#697586"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0af78a5e4647e6f591566c9eb75b38c0.svg";
export { ForwardRef as ReactComponent };